import { useState, useEffect, useContext, createContext } from "react";
import axios from "axios";

const AuthContext = createContext();
const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    token: "",
  });

  //default axios
  axios.defaults.headers.common["Authorization"] = auth?.token;

  useEffect(() => {
    const data = localStorage.getItem("auth");
    if (data) {
      const parseData = JSON.parse(data);
      setAuth((prev) => ({
        ...prev,
        user: parseData.user,
        token: parseData.token,
      }));

      // Silently sync the latest user data (critical for live discounts)
      axios.get("/api/v1/auth/me", {
        headers: { Authorization: parseData.token }
      }).then(({ data }) => {
        if (data?.success && data?.user) {
          setAuth((prev) => {
            const newAuth = { ...prev, user: data.user };
            localStorage.setItem("auth", JSON.stringify(newAuth));
            return newAuth;
          });
        }
      }).catch(console.error);
    }
    //eslint-disable-next-line
  }, []);
  return (
    <AuthContext.Provider value={[auth, setAuth]}>
      {children}
    </AuthContext.Provider>
  );
};

// custom hook
const useAuth = () => useContext(AuthContext);

export { useAuth, AuthProvider };
